import { Image } from "@chakra-ui/react";
import { Logo } from "components/vectors/logo";
import { AurusPromotoraLogo } from "components/vectors/logo/aurus-logo";
import { SuportCredLogo } from "components/vectors/logo/benisolutions";
import { CapitalSolucoesLogo } from "components/vectors/logo/capital-solucoes-logo";
import { CheckNegociosLogo } from "components/vectors/logo/check-negocios";
import { ConsultoriaPromotora } from "components/vectors/logo/consultoria-promotora";
import { DexPromotora } from "components/vectors/logo/dex-promotora";
import { EntrouNaConta } from "components/vectors/logo/entrounaconta";
import { FacilittaPromotoraLogo } from "components/vectors/logo/facilitta-promotora-logo";
import { LogoImediata } from "components/vectors/logo/imediata";
import { MaisAgilLogo } from "components/vectors/logo/mais-agil-logo";
import { MelhorCreditoLogo } from "components/vectors/logo/melhor-credito-logo";
import { LogoNexttPromotora } from "components/vectors/logo/next-promotora";
import { ProfitPromotoraLogo } from "components/vectors/logo/profit-promotora";
import { RagazziLogo } from "components/vectors/logo/ragazzi-logo";
import { SharkLogo } from "components/vectors/logo/shark";
import { SolidaPromotora } from "components/vectors/logo/solida-promotora";
import { SolideCredLogo } from "components/vectors/logo/solide-cred";
import { getDomainKeySelect } from "utils/verify-domain";

export const getLogo = () => {
  return (
    {
      maisagil: <MaisAgilLogo />,
      imediata: <LogoImediata />,
      suapromotora: (
        <Image width="100%" src="/assets/layout/images/sua-promotora.png" />
      ),
      solassessoria: (
        <Image width="90%" src="/assets/layout/images/logo-sol-promotora.png" />
      ),
      sharkpromotora: <SharkLogo />,
      solidapromotora: <SolidaPromotora />,
      entrounaconta: <EntrouNaConta />,
      nexttpromotora: <LogoNexttPromotora />,
      capitalsolucoes: <CapitalSolucoesLogo />,
      benisolutions: <SuportCredLogo />,
      checknegocios: <CheckNegociosLogo />,
      dex: <DexPromotora />,
      solidecred: <SolideCredLogo />,
      auruspromotora: <AurusPromotoraLogo />,
      profitpromotora: <ProfitPromotoraLogo />,
      consultoriapromotora: <ConsultoriaPromotora />,
      melhorcredito: <MelhorCreditoLogo />,
      ragazzi: <RagazziLogo />,
      facilittapromotora: <FacilittaPromotoraLogo />,
    }[getDomainKeySelect()] ?? <Logo />
  );
};

export const getNavbarLogo = () => {
  return (
    {
      maisagil: <MaisAgilLogo width="80px" height="auto" />,
      imediata: <LogoImediata width="140px" />,
      suapromotora: (
        <Image width="180px" src="/assets/layout/images/sua-promotora.png" />
      ),
      solassessoria: (
        <Image
          width="140px"
          src="/assets/layout/images/logo-sol-promotora.png"
        />
      ),
      sharkpromotora: <SharkLogo width="180px" />,
      solidapromotora: <SolidaPromotora width="150px" />,
      entrounaconta: <EntrouNaConta width="150px" />,
      nexttpromotora: <LogoNexttPromotora width="120px" />,
      capitalsolucoes: <CapitalSolucoesLogo width="220px" />,
      benisolutions: <SuportCredLogo width="110px" />,
      checknegocios: <CheckNegociosLogo width="160px" />,
      dex: <DexPromotora width="90px" />,
      solidecred: <SolideCredLogo width="100px" />,
      auruspromotora: (
        <AurusPromotoraLogo width="100px" display="block" mt="-6px" />
      ),
      profitpromotora: <ProfitPromotoraLogo width="140px" />,
      consultoriapromotora: <ConsultoriaPromotora width="50px" />,
      melhorcredito: <MelhorCreditoLogo width="140px" />,
      ragazzi: <RagazziLogo width="150px" />,
      facilittapromotora: <FacilittaPromotoraLogo width="80px" />,
    }[getDomainKeySelect()] ?? <Logo width="177px" height="34px" />
  );
};

export const getTitle = () => {
  return (
    {
      maisagil: "+Ágil Promotora",
      imediata: "Imediata Brasil Promotora",
      suapromotora: "Sua Promotora",
      solassessoria: "Sol Assessoria",
      sharkpromotora: "Shark Promotora",
      solidapromotora: "Sólida Promotora",
      entrounaconta: "Entrou Na Conta Promotora",
      mendespromotora: "Mendes Promotora",
      nexttpromotora: "Nextt Promotora",
      capitalsolucoes: "Capital Soluções Promotora",
      benisolutions: "SuportCred Promotora",
      checknegocios: "Check Negócios Promotora",
      dex: "Dex Promotora",
      solidecred: "Sólide Cred",
      auruspromotora: "Aurus Promotora",
      profitpromotora: "Profit Promotora",
      consultoriapromotora: "Consultoria Promotora",
      melhorcredito: "Melhor Crédito Promotora",
      ragazzi: "Ragazzi Promotora",
      facilittapromotora: "Facilitta Promotora",
    }[getDomainKeySelect()] ?? "Nova Promotora"
  );
};

export const getFavIcon = () => {
  var link: HTMLLinkElement = document.querySelector(
    "link[rel~='icon']"
  ) as HTMLLinkElement;

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  if (getDomainKeySelect() === "solidapromotora") {
    link.href = "/favicon-solida.png";
  }
};
